const MoneyMil = [
    {id: "100", value: "100萬"},    
    {id: "200", value: "200萬"},
    {id: "300", value: "300萬"},             
  ];  
  
  export default MoneyMil